import {Collection} from 'vue-mc'
import InterpreterModel from "../models/interpreterModel";

/**
 * Task collection
 */
export default class InterpreterCollection extends Collection {

    model() {
        return InterpreterModel;
    }

    // Default attributes
    defaults() {
        return {
            orderBy: 'interpreterId',
        }
    }

    // Route configuration
    routes() {
        return {
            fetch: '',
            getRecruitmentInfo: 'charts/getRecruitmentInfo',
        }
    }
}



// WEBPACK FOOTER //
// ./src/collections/interpreterCollection.js